import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFetchTable } from "@hooks/useFetchDataTable";
import Table from "@components/Table";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import ModalDownloadUploadCst from "@components/ModalDownloadUploadCst";
import { ActionUploadDownloadIterface } from "@components/ModalDownloadUploadCst/types";
import { downloadFile, uploadFile } from "@utils/utilsApi";
import { ActionsType } from "src/interfaces/Common";
import { KeyURL } from "src/services/type";
import AnimationFadeIn from "@components/AnimationFadeIn";
import CustomRowAction from "@components/Table/components/CustomRowAction";
import { Visibility } from "@mui/icons-material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { useParams } from "react-router-dom";
import ModalCst from "@components/ModalCst";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@context/auth";
import { useFilters } from "@context/filters";

const LearningObjectProject: React.FC = () => {
  const [openUpload, setOpenUpload] = useState<ActionUploadDownloadIterface>();
  const [openModalModule, setOpenModalModule] = useState(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { idProject, id } = useParams();
  const navigate = useNavigate();
  const [dataDetail, setDataDetail] = useState();

  const { user } = useAuth();
  const { filters } = useFilters();
  const filterId = `${user?.id_user}_${PagesID["projects.learning-object"]}`;

  const { columns, dataTable, actionsTopToolbar, actionForRow, mutate } =
    useFetchTable(
      `${ServicesURL.getProjectsLearningObject.replace(
        ":budgetProjectId",
        `${idProject}`,
      )}`,
      PagesID["projects.learning-object"],
      filters[filterId],
    );

  const { columns: dataDetailColumns, actionForRow: detailActionForRow } =
    useFetchTable(
      `${ServicesURL.getProjectsLearningObject.replace(":budgetProjectId", `${idProject}`)}`,
      PagesID["projects.learning-object-module"],
      filters[`${user?.id_user}_${PagesID["projects.learning-object-module"]}`],
    );

  const { t } = useTranslation(["projects-learning-object-page"]);
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
  }>();

  const onSubmitModal = async (selectedRoles: any, list: any) => {
    mutate && mutate();
  };

  const dataFormat = useMemo(() => {
    if (!dataTable?.output) return [];

    return dataTable.output.map((el: any) => {
      return el;
    });
  }, [dataTable?.output]);

  const filteredColumns = useMemo(() => {
    if (columns) {
      return columns.map((el) => {
        return { ...el };
      });
    }
  }, [columns]);

  const configurationActionForRow: ActionsType[] = React.useMemo(() => {
    return actionForRow?.map((action: any) => {
      switch (action.type) {
        case "button": {
          return {
            ...action,
            callBack: (row: any) => {
              setDataDetail(row.action_modules);
              setOpenModalModule(true);
            },
            getIcon: (row: any) => {
              return <Visibility />;
            },
          };
        }
        default:
          return action;
      }
    });
  }, [actionForRow]);

  const configurationActionForRowDetail: ActionsType[] = React.useMemo(() => {
    return detailActionForRow?.map((action: any) => {
      switch (action.type) {
        case "link": {
          if (action.key === "manage-action-module") {
            return {
              ...action,
              callBack: (row: any) =>
                navigate(
                  `/corporate/${id}/detail/foundedTraining/managePlan/${row.financing_plan_id}/projects/${row.project_id}/modules/edit/${row.id}`,
                ),
            };
          }
          break;
        }
        default:
          return action;
      }
    });
  }, [detailActionForRow]);

  const customRenderRowActions = ({ row }: { row: any }): React.ReactNode => {
    let configRowNew: any = configurationActionForRow && [
      ...configurationActionForRow,
    ];

    //FUNZIONE PER ABILITAZIONE/ DISABILITAZIONE CAMPI IN BASE A VALORI DELLA ROW
    configRowNew = configRowNew.map((el: ActionsType) => {
      if (
        el.key === "manage-learning-objects-module" &&
        row.original?.action_modules < 1
      ) {
        return { ...el, disabled: true };
      }

      return { ...el };
    });

    return [
      <CustomRowAction
        key={row.id}
        row={row}
        configurationActionForRow={configRowNew}
      />,
    ];
  };

  const customRenderRowActionsDetail = ({
    row,
  }: {
    row: any;
  }): React.ReactNode => {
    let configRowNew: any = configurationActionForRowDetail && [
      ...configurationActionForRowDetail,
    ];

    //FUNZIONE PER ABILITAZIONE/ DISABILITAZIONE CAMPI IN BASE A VALORI DELLA ROW
    configRowNew = configRowNew.map((el: ActionsType) => {
      if (
        el.key === "manage-learning-objects-module" &&
        row.original?.action_modules < 1
      ) {
        return { ...el, disabled: true };
      }
      return { ...el };
    });

    return [
      <CustomRowAction
        key={row.id}
        row={row}
        configurationActionForRow={configRowNew}
      />,
    ];
  };

  const actionsToolbar: ActionsType[] | undefined = React.useMemo(() => {
    return actionsTopToolbar?.map((action: ActionsType) => {
      switch (action.type) {
        case "button":
          return {
            ...action,
            getIcon: () => <ModeEditIcon />,
            callBack: () => setOpenModal(true),
          };
        case "upload": {
          const actionModal: ActionUploadDownloadIterface = {
            ...action,
            ...{
              service: `${ServicesURL[action.service as KeyURL]}?corporate_id=1`,
              types: ["upload", "download", "template"],
              onDownload: (el) =>
                downloadFile(
                  `${ServicesURL[action.service as KeyURL]}/download${
                    el ? `/${el}` : ""
                  }?corporate_id=1&type=LEARNER` || "",
                ),
              onUpload: (formData: FormData) => {
                return uploadFile(
                  `${ServicesURL[action.service as KeyURL]}?corporate_id=1`,
                  formData,
                );
              },
            },
          };
          return {
            ...action,
            ...{ callBack: () => setOpenUpload(actionModal) },
          };
        }
        default:
          return action;
      }
    });
  }, [actionsTopToolbar]);

  return (
    <AnimationFadeIn>
      <Table
        id={PagesID.projects}
        data={dataFormat || []}
        columns={filteredColumns || []}
        configurationTopToolbar={actionsToolbar}
        renderRowActions={customRenderRowActions}
        totalPages={dataTable?.metadata?.total_elements}
        modalTitle={t("hero-title")?.replace("-", "") || ""}
      />
      <ModalConfirmsCst
        open={!!openModalModule}
        title={t("hero-modal-title")}
        description={""}
        children={
          <Table
            id={PagesID["projects.learning-object-module"]}
            data={dataDetail || []}
            columns={dataDetailColumns || []}
            totalPages={dataTable?.metadata?.total_elements}
            modalTitle={t("hero-title")?.replace("-", "") || ""}
            hiddenFilters={true}
            enableFullScreenToggle={false}
            renderRowActions={customRenderRowActionsDetail}
            renderTopToolbar={false}
          />
        }
        onCallBackClosed={() => {
          setOpenModalModule(false);
        }}
        status={openToast}
        removeButtons={true}
      />
      <ModalCst
        open={openModal}
        setOpen={setOpenModal}
        title={"Dettaglio"}
        typeOfModal={"AddLearningObjectProject"}
        onSubmit={onSubmitModal}
        fullWidth={true}
      />
      <ModalDownloadUploadCst
        open={!!openUpload}
        setOpen={() => {
          setOpenUpload(undefined);
        }}
        title={openUpload?.labelTranslate || ""}
        data={openUpload}
      />
    </AnimationFadeIn>
  );
};

export default LearningObjectProject;
